import * as React from "react";
import { RBACButton } from "../../../molecules/rbac-button";
import { ProcedureEntity } from "../../../../application/domain/procedures/procedure-entity";
import { useAuthContextV2 } from "../../../../auth-state";
import { SecondaryButton } from "@graffer-inc/console-design-kit";

export const UpdateButton: React.FC<{
  procedure: ProcedureEntity;
  disabled?: boolean;
  canModifyAfterPublish?: boolean;
  canModifyCustomTag?: boolean;
  onClick: () => void;
}> = ({
  procedure,
  disabled,
  canModifyAfterPublish,
  onClick,
  canModifyCustomTag,
}) => {
  const authState = useAuthContextV2();

  if (!canModifyAfterPublish && procedure.isPublished()) {
    return null;
  }

  if (procedure.isArchived()) {
    return null;
  }

  if (!canModifyCustomTag && procedure.customTag) {
    return null;
  }

  return (
    <>
      {authState.auth.isServiceProviderAccount() &&
        procedure.isGrafferManaged && (
          <SecondaryButton
            text={"更新する"}
            disabled={disabled}
            onClick={onClick}
          />
        )}
      {!authState.auth.isServiceProviderAccount() &&
        !procedure.isGrafferManaged && (
          <RBACButton
            target={procedure}
            requirePermissions={"procedures.update"}
            className="button is-outlined is-info"
            disabled={disabled}
            onClick={onClick}
            buttonText={"更新する"}
            buttonTypes={"secondary"}
          />
        )}
    </>
  );
};
